import { withSuspense } from '@/ui/utils/withSuspense'

import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { RepayView } from './views/RepayView'
import { IsolatedPairOverview } from '@/features/isolated-details/types'
import { useRepayDialog } from './logic/useRepayDialog'

type RepayDialogContentContainerProps = { closeDialog: () => void } & {
  walletOverview: MyWalletProps
  pairOverview: IsolatedPairOverview
}

function RepayDialogContentContainer({ closeDialog, walletOverview, pairOverview }: RepayDialogContentContainerProps) {
  const {
    objectives,
    actionsContext,
    repayOptions,
    assetsToRepayFields,
    pageStatus,
    form,
    repayAsset,
    currentPositionOverview,
    updatedPositionOverview,
    updatedLiquidationPrice,
  } = useRepayDialog({ walletOverview, pairOverview })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="isolatedRepay"
        tokenWithValue={repayAsset}
        onProceed={closeDialog}
        proceedText="View in dashboard"
      />
    )
  }

  return (
    <RepayView
      walletOverview={walletOverview}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      repayOptions={repayOptions}
      objectives={objectives}
      actionsContext={actionsContext}
      form={form}
      assetsToRepayFields={assetsToRepayFields}
      pageStatus={pageStatus}
      repayAsset={repayAsset}
      pairOverview={pairOverview}
      updatedLiquidationPrice={updatedLiquidationPrice}
    />
  )
}

const RepayDialogContentContainerWithSuspense = withSuspense(RepayDialogContentContainer, DialogContentSkeleton)
export { RepayDialogContentContainerWithSuspense as RepayDialogContentContainer }
